export * from "./thread";
export type AgentCategory =
  | "Business Foundations"
  | "AI Tool Use"
  | "LinkedIn"
  | "Content Creation"
  | "Lead Generation"
  | "Sales"
  | "Project Management";

export type PhosphorIconName =
  | "Crosshair"
  | "ChartBar"
  | "CurrencyDollar"
  | "User"
  | "PencilLine"
  | "Phone"
  | "Scroll"
  | "FileText"
  | "Lightning"
  | "Wrench"
  | "Rocket"
  | "Toolbox";

export interface Agent {
  id: string;
  name: string;
  description: string;
  category: AgentCategory;
  iconName: PhosphorIconName;
  prompt: string;
  isOnboarding?: boolean;
}

export const ONBOARDING_AGENT_ID = "onboarding-guide";
